import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import { FaSearch, FaPlus } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customStyles } from '~/Styles/reactSelectStyles';
import { cleanCpfCnpj } from '~/Utils/Helpers';
import * as api from '~/Services/Service';

const STATUS_OPTIONS = [
  { value: 'V', label: 'Válidos' },
  { value: 'E', label: 'Expirados' },
  { value: 'T', label: 'Todos' },
];

const FiltroAlerta = ({ filtros, onChange, onBuscar, onNovo, carregando }) => {
  const [opcoesGE, setOpcoesGE] = useState([]);
  const [opcoesCliente, setOpcoesCliente] = useState([]);
  const [carregandoClientes, setCarregandoClientes] = useState(false);

  useEffect(() => {
    const carregarGEs = async () => {
      try {
        const res = await api.listarTodosGruposEmpresa();
        const lista = res || [];
        setOpcoesGE(
          lista.map((ge) => ({
            value: ge.codigo,
            label: ge.apelido,
          }))
        );
      } catch (e) {
        toast.error('Erro ao carregar grupos de empresa.');
      }
    };
    carregarGEs();
  }, []);

  useEffect(() => {
    if (!filtros.codigoGrupoEmpresa) {
      setOpcoesCliente([]);
      return;
    }
    const carregarClientes = async () => {
      setCarregandoClientes(true);
      try {
        const res = await api.listarClientesPorGrupoEmpresa(
          filtros.codigoGrupoEmpresa
        );
        const lista = res || [];
        setOpcoesCliente(
          lista.map((c) => ({ value: c.codigo, label: c.apelido }))
        );
      } catch (e) {
        toast.error('Erro ao carregar clientes.');
      } finally {
        setCarregandoClientes(false);
      }
    };
    carregarClientes();
  }, [filtros.codigoGrupoEmpresa]);

  const geValue =
    opcoesGE.find((o) => o.value === filtros.codigoGrupoEmpresa) || null;

  const clienteValue =
    opcoesCliente.find((o) => o.value === filtros.codigoConta) || null;

  const statusValue =
    STATUS_OPTIONS.find((o) => o.value === filtros.status) || STATUS_OPTIONS[0];

  const handleGEChange = (selected) => {
    onChange({
      ...filtros,
      codigoGrupoEmpresa: selected ? selected.value : null,
      codigoConta: null,
    });
  };

  const handleClienteChange = (selected) => {
    onChange({ ...filtros, codigoConta: selected ? selected.value : null });
  };

  const handleCpfChange = (e) => {
    onChange({ ...filtros, cpf: cleanCpfCnpj(e.target.value) });
  };

  const handleNomeChange = (e) => {
    onChange({ ...filtros, nome: e.target.value });
  };

  const handleStatusChange = (selected) => {
    onChange({ ...filtros, status: selected ? selected.value : 'V' });
  };

  const handleBuscar = () => {
    onBuscar();
  };

  return (
    <Card className="shadow-sm mb-3">
      <Card.Body className="py-2">
        <Row className="align-items-end">
          <Col xs={12} md={3} className="mb-2">
            <Form.Label className="small mb-1">GE</Form.Label>
            <Select
              options={opcoesGE}
              value={geValue}
              onChange={handleGEChange}
              placeholder="Selecione..."
              isClearable
              styles={customStyles}
            />
          </Col>
          <Col xs={12} md={3} className="mb-2">
            <Form.Label className="small mb-1">Cliente</Form.Label>
            <Select
              options={opcoesCliente}
              value={clienteValue}
              onChange={handleClienteChange}
              placeholder={
                filtros.codigoGrupoEmpresa
                  ? carregandoClientes
                    ? 'Carregando...'
                    : 'Selecione...'
                  : 'Selecione um GE primeiro'
              }
              isClearable
              isDisabled={!filtros.codigoGrupoEmpresa || carregandoClientes}
              styles={customStyles}
            />
          </Col>
          <Col xs={12} md={2} className="mb-2">
            <Form.Label className="small mb-1">CPF/CNPJ</Form.Label>
            <Form.Control
              type="text"
              value={filtros.cpf || ''}
              onChange={handleCpfChange}
              maxLength={14}
            />
          </Col>
          <Col xs={12} md={2} className="mb-2">
            <Form.Label className="small mb-1">Nome</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nome do cliente..."
              value={filtros.nome || ''}
              onChange={handleNomeChange}
            />
          </Col>
          <Col xs={12} md={2} className="mb-2">
            <Form.Label className="small mb-1">Status</Form.Label>
            <Select
              options={STATUS_OPTIONS}
              value={statusValue}
              onChange={handleStatusChange}
              styles={customStyles}
              isSearchable={false}
            />
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={handleBuscar}
              disabled={carregando}
              className="mr-2"
            >
              <FaSearch className="mr-1" />
              Buscar
            </Button>
            <Button variant="success" onClick={onNovo}>
              <FaPlus className="mr-1" />
              Novo
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FiltroAlerta;
